import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProjectCastList.html?raw';
import on from 'dojo/on';
import Checkbox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';

import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import PageStack from '../../../moreCore/UI/Tabbing/PageStack';
import "../../../moreCore/UI/Tabbing/PageStack";
import { HtmlHelpers, TranslationHelpers } from "../../../more/Helpers";
import EvCastEditor from '../../EvCast/EvCastEditor';
import CommdocEditor from '../../Commdoc/CommdocEditor/CommdocEditor';


interface RedEntry extends VAM2types.EvCastEvProject {
    is_red_entry?: boolean,
}

class EvProjectCastList extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
	templateString: any = template;
    private performerInput: MdsLax<InstanceType<typeof HintBox>>;
    private castRedInput_Name: MdsLax<InstanceType<typeof Edit>>;
    private castRedInput_Role: MdsLax<InstanceType<typeof Edit>>;

    private sectionAddEntry: HTMLElement;
    private addEntryPagestack: MdsLax<InstanceType<typeof PageStack>>;
    //redEntryInputContainer: HTMLElement;
    private addRedEntryButton: HTMLButtonElement;

    private redEntry: RedEntry;

    private tableContainer: HTMLElement;
    private tableContainerIndividual: HTMLElement;
    private sectionIndividual: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.EvCastEvProject>>>;
    private evProjectID: string;
    private entitylist_synced: Array<VAM2types.EvCastEvProject>;
    private entitylist_individual: Array<VAM2types.EvCastEvProject>;

    private _tableLayout: StaticTable.RowConfig = {
        "attributes": ["ID", "c_cast_address", "c_cast_perfomer"],
        colNamesInternal: ["sync", "c_cast_address", "c_cast_perfomer"],
        "headings": ["EvCast_Label__SyncToEvBooking", "EvCast_Label__Address", "EvCast_Label__Role"],
        widths: ["15ch", null, null/*, "15ch"*/],
        alignmentsHeading: [null, null/*, "right"*/],
        alignmentsRow: [null, null, null/*, "right"*/]
    };

    protected _tableLayoutStatus: StaticTable.RowConfig = {
        "attributes": ["ID", "c_cast_address", "c_cast_perfomer", "ref_ev_cast_status.description"],
        colNamesInternal: ["sync", "c_cast_address", "c_cast_perfomer", "ref_ev_cast_status.description"],
        "headings": ["EvCast_Label__SyncToEvBooking", "EvCast_Label__Address", "EvCast_Label__Role", "General_Label_Status"],
        widths: ["15ch", null, null, null/*, "15ch"*/],
        alignmentsHeading: [null, null, null/*, "right"*/],
        alignmentsRow: [null, null, null, null/*, "right"*/],
        bgColors: [null, null, null, "ref_ev_cast_status.coloration"/*, "right"*/]
    };

    private _tableFormatter(cell: StaticTable.StaticTableCell<RedEntry>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        this.UiModder.domClass.toggle(node, "w3-text-red", !entity.ref_performer);

        switch (colName) {
            case "sync":
                if (entity.is_synced_from_booking) {
                    cell.contentnode.innerHTML = TranslationHelpers.translate("EvCast_Label__Individual");
                    HtmlHelpers.createFontawesomeIcon("fas fa-ban", "right", cell.contentnode);
                    this.disableNode(cell.contentnode);
                    this.hideNode(cell.tableCellNode);
                } else {
                    let cb = new Checkbox();
                    cb.setType("toggle");
                    cb.setLabel("EvCast_Label__Sync");
                    cb.placeAt(cell.contentnode);
                    cb.setValue(entity.is_sync_typ_A, true);
                    

                    if (this.hasUserRole("EvCast_Edit")) {
                        on(cb, "change", lang.hitch(this, this._onChange_SyncType, entity));
                    } else {
                        cb.setReadonly(true);
                    }
                }
                return true;
                break;
        }

        return false;
    }
    private _tableHeaderFormatter(heading: string, colName: string, node: HTMLElement) {
       
        switch (colName) {
            case "sync":
                this.hideNode(node, true, true);
                return "";
                break;
        }

        return false;
    }

    private _onChange_SyncType(entity: RedEntry, isSync: boolean) {
        if (entity.is_synced_from_booking) return;

        entity.is_sync_typ_A = isSync;
        this.store.changeEntry(entity, true);
    }

    private _onChange_StoreData() {
        let diffData = this.store.getDiffData();
        let completeList = this.store.getCurrentCompleteList();

        if (!this.table) {
            this.setupTables();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData);

        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        this._delayEmit();
    }

    private _emitHandle: any = null;    
    private _delayEmit() {
        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }


        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", this.getData()), 100);

    }
    private _onChangePerformerInput(): void {
        let value = this.performerInput.getValue() as VAM2types.Performer;

        if (value != null) {
            let fakeCast: Partial<VAM2types.EvCastEvProject> = {
                ID: (Math.random() * 100000).toString(),
                $Displayname: `${value.gDisp_1}`,
                c_cast_address: value.ref_address.gDisp_1,
                c_cast_perfomer: value.ref_ev_profession.description,
                ref_performer: value,
                is_sync_typ_A: true,
                is_synced_from_booking: false
            }

            this.store.addEntry(fakeCast as any);

            this.performerInput.setValue(null, true);
        }
    }

    getData() {
        return this.store.getCurrentCompleteList();
    }
    getDiffData() {
        let diffData = this.store.getDiffData();
        return diffData;
    }

    private setupTables(): void {

        this.tableContainer.innerHTML = null;
        this.tableContainerIndividual.innerHTML = null;
        this.hideNode(this.sectionIndividual);

        this.table = new StaticTable();

        
        //this.table.setGroupingParameter("is_synced_from_booking", null, [false, true], ["EvCast_Label__SyncedFromEvProject", "EvCast_Label__SyncedFromEvBooking"]);

        if (this.hasUserRole("EvCast_Edit")) this.table.setupRowSorting("order");//, lang.hitch(this, this._onRowSorting));
        this.table.setFormatter(lang.hitch(this, this._tableFormatter));

        if (this.hasFeature("EvProject/PerformerContract")) {
            this.table.addCustomRowActionButton("performerContract_New",
                lang.hitch(this, this._onClickPerformerNewContractBtn),
                "fas fa-file-contract",
                null, null, this.translate("Document_Label_NewPerformerContract"),
                (e: VAM2types.EvCastEvProject) => { return e.ref_performer_contract == null }, true);
            this.table.addCustomRowActionButton("performerContract_Edit",
                lang.hitch(this, this._onClickPerformerContractEditorBtn),
                "fas fa-file-signature",
                null, null, this.translate("Document_Label_EditPerformerContract"),
                (e: VAM2types.EvCastEvProject) => { return e.ref_performer_contract != null }, true);
        }


        if (this.hasUserRole("EvCast_Delete")) this.table.addDefaultRowActionButton("delete");//, lang.hitch(this, this._onRowDeleting));

        if (this.hasFeature("Planning/EvCastStatus")) this.table.addLineConfig(this._tableLayoutStatus);
        else this.table.addLineConfig(this._tableLayout);

        this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditCast));
        this.table.setCyAttribute("EvProjectCastList");

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //this.table.setData(this.entitylist);
        this.table.setupFromStore(this.store);

        // individuell:
        if (this.entitylist_individual?.length) {
            this.hideNode(this.sectionIndividual, false);

            let individualTable = new StaticTable();
            //individualTable.setLabel("EvCast_Label__SyncedFromEvBooking");
            
            individualTable.addLineConfig(this._tableLayout);

            individualTable.setFormatter(lang.hitch(this, this._tableFormatter));
            individualTable.setHeadingLabelFormatter(this._tableHeaderFormatter);
            individualTable.setCyAttribute("EvProjectCastListIndividualTable");

            individualTable.setData(this.entitylist_individual);
            individualTable.placeAt(this.tableContainerIndividual);

        }
    }

    private _onClickPerformerNewContractBtn(rowGroup: StaticTable.StaticTableRowGroup<VAM2types.EvCastEvProject>) {
        let cast = rowGroup.entity;
        if (cast.Classname != "ev_cast_ev_project") {
            this._showErrorMessage(this.translate("Document_Message_SaveChanges"));
            return;
        }
        this.StandbyStart();

        if (this.hasFeature("Commdoc/PerformerContractType")) {
            this.RequestManager.callfunction(
                "Webtool_API_Document__DocumentEditor_GetPerformerContractTypes",
                null,
                lang.hitch(this, this._selectPerformerContractType, cast),
                lang.hitch(this, this._showErrorMessage)
            )
        } else {
            this.RequestManager.callfunction(
                "Webtool_API_Document__DocumentEditor_CreateNewPerformerContract",
                {
                    castID: cast.ID
                },
                lang.hitch(this, this._openPerformerContractEditor, cast),
                lang.hitch(this, this._showErrorMessage)
            )
        }


    }

    private _selectPerformerContractType(cast: VAM2types.EvCastEvProject, response: Array<VAM2types.Entity_description>) {
        this.hourGlassEnd(this);

        let select = new SearchSelect();
        select.setData(response[0], response, true, "description");
        select.setMandatory(true);
        this.UiModder.domClass.add(select.domNode, "padding");

        let dlg = new GenericDialog();
        dlg.enableContentOverflow(true);

        select.on("change", () => { dlg.enableButton("ok", select.isValid) })

        dlg.show(select,
            this.translate("Document_Label_ContractTypeSelect"),
            null, null,
            "okcancel",
            (res) => {
                if (res === 1) {
                    this.StandbyStart();
                    this.RequestManager.callfunction(
                        "Webtool_API_Document__DocumentEditor_CreateNewPerformerContract",
                        {
                            castID: cast.ID,
                            typeID: select.getValue()
                        },
                        lang.hitch(this, this._openPerformerContractEditor, cast),
                        lang.hitch(this, this._showErrorMessage)
                    )
                }
            });
    }

    private _onClickPerformerContractEditorBtn(rowGroup: StaticTable.StaticTableRowGroup<VAM2types.EvCastEvProject>) {

        let cast = rowGroup.entity;

        this._openPerformerContractEditor(cast, cast.ref_performer_contract);
        //let editor = new DocumentEditor();
        //editor.on("saved", lang.hitch(this, this.reload));
        //editor.on("deleted", lang.hitch(this, this.reload));
        //editor.setup(entity.ref_performer_contract, "performer_contract");
    }

    private _openPerformerContractEditor(cast: VAM2types.EvCastEvProject, contract: VAM2types.Entity_gDisp) {

        if (!cast.ref_performer_contract && contract.ID) cast.ref_performer_contract = contract;
        this.table.enableActionButton("performerContract_New", cast, false);
        this.table.enableActionButton("performerContract_Edit", cast, true);

        let editor = new CommdocEditor();
        editor.setStartupState("loading");
        editor.setup("performer_contract", contract.ID);
        editor.on("saved", lang.hitch(this, this._onPerformerContractSaved));

        this.StandbyStop();
    }

    private _onPerformerContractSaved() {
        debugger;
        this.emit("performerContractSaved")
    }

    private _onClickEditCast(row: StaticTable.StaticTableRowGroup<VAM2types.EvCastEvProject>) {
        let editor = new EvCastEditor();
        editor.setup(row.entity);

        editor.on("confirmed", lang.hitch(this, this._onConfirmedCastEditor))
    }

    private _onConfirmedCastEditor(data: VAM2types.EvCastEvProject) {
        this.store.changeEntry(data, true);
    }

    private _onClick_OpenEvCastSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvCast_EvProject",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }

    private _onCallback_Dlg(mode: string, data, items) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        if (!items || !items.length) return;

        for (let item of items) {
            let entity = {
                ID: item.entry.value, gDisp_1: item.entry.label
            }

            if (mode == "selectEvCast_EvProject") {
                this.performerInput.setValue(item.entry.data);
            }
            //this.previousSEDvalue = items;
        }
    }



    private _onChangeRedInput(value: any): void {

        if (value != null) this.redEntry = {
            $Displayname: "",
            ID: null,
            Classname: VAMclassNames.ev_cast,
            is_red_entry: true,
            order: null,
            is_synced_from_booking: false,
            is_sync_typ_A: true,
            c_cast_address: this.castRedInput_Name.getValue(),
            c_cast_perfomer: this.castRedInput_Role.getValue(),
            ref_performer: null
        };

        let readyCheck = this.castRedInput_Name.getValue() ||
            this.castRedInput_Role.getValue();
        //this.opusRedInput_Author.getValue() ||
        //this.opusRedInput_Duration.getValue() != null;

        this.UiModder.domClass.toggle(this.addRedEntryButton, "w3-disabled", !readyCheck);
    }


    private _onClickAddRedEntryButton(): void {

        let fakeCast: Partial<VAM2types.EvCastEvProject> = {
            ID: (Math.random() * 100000).toString(),
            ref_performer: null,
            c_cast_address: this.redEntry.c_cast_address,
            c_cast_perfomer: this.redEntry.c_cast_perfomer
        }

        //this.store.reset();

        this.store.addEntry(fakeCast as any);

        this.performerInput.setValue(null, true);
        this.castRedInput_Name.setValue(null, true);
        this.castRedInput_Role.setValue(null, true);

    }



    setup(syncedEntities: Array<VAM2types.EvCastEvProject>, individualEntities: Array<VAM2types.EvCastEvProject>, evProjectID: string) {
        this.store.setup(syncedEntities, "ID");
        this.evProjectID = evProjectID;
        this.entitylist_synced = syncedEntities;
        this.entitylist_individual = individualEntities;

        this.setupTables();
    }
    private _showErrorMessage(err?: more.requestErrorMessage | string) {
        this.StandbyStop();
        let msg;

        if (typeof err == "string") msg = err;
        else msg = err ? err.Message : "...error occured";

        this.showToast(msg, "fas fa-exclamation-triangle");
    }
    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        this.hideNode(this.sectionAddEntry, !this.hasUserRole("EvCast_Create"));

        if (this.hasFeature("EvCast/disableCatalogSelection")) {
            this.addEntryPagestack.hidePage("select");
        }
        if (this.hasFeature("EvCast/disableRedEntries")) {
            this.addEntryPagestack.hidePage("redEntry");
        }

       
        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        this.performerInput.addInlineButton(lang.hitch(this, this._onClick_OpenEvCastSED));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProjectCastList);